import HttpClient from './HttpClient';

const WhatsAppService = {
  getStatusMessage: (params) => {
    const path = 'wa';
    return HttpClient.get(path, params, true);
  },
  getMessageCosto: (params) => {
    let path = 'wa/cost';
    return HttpClient.get(path, params, true);
  }
};

export default WhatsAppService;
